import React, { useState } from "react";
import { Box, Button, HStack, Input, Text, Wrap, WrapItem } from "@chakra-ui/react";

export function ConfirmActionWidget({ prompt, options, onSend }) {
  const opts = options && options.length > 0 ? options : ["Yes", "No"];
  const [note, setNote] = useState("");
  const [submitted, setSubmitted] = useState(null);

  const sendValue = (value) => {
    setSubmitted(value);
    onSend(value);
  };

  const handleFreeSubmit = () => {
    const trimmed = note.trim();
    if (!trimmed) return;
    sendValue(trimmed);
  };

  if (submitted) {
    return (
      <Box bg="gray.50" borderWidth="1px" borderRadius="md" p={3} my={2}>
        <Text fontSize="xs" color="gray.500" mb={1}>
          {prompt}
        </Text>
        <Text fontSize="sm">✓ {submitted}</Text>
      </Box>
    );
  }

  return (
    <Box bg="white" borderWidth="1px" borderRadius="md" p={3} my={2}>
      <Text fontSize="sm" fontWeight="medium" mb={2}>
        {prompt}
      </Text>
      <Wrap spacing={2} mb={2}>
        {opts.map((opt) => (
          <WrapItem key={opt}>
            <Button size="sm" variant="outline" onClick={() => sendValue(opt)}>
              {opt}
            </Button>
          </WrapItem>
        ))}
      </Wrap>
      <HStack>
        <Input
          size="sm"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleFreeSubmit()}
          placeholder="Other..."
        />
        <Button size="sm" variant="ghost" onClick={handleFreeSubmit} isDisabled={!note.trim()}>
          Send
        </Button>
      </HStack>
    </Box>
  );
}
